/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';

import shipsticksLoadingImage from '../images/shipsticks/loader.gif';
import shipskisLoadingImage from '../images/shipskis/loader.gif';
import shipgoLoadingImage from '../images/shipgo/loader.gif';
import shipcampsLoadingImage from '../images/shipcamps/loader.gif';
import shipschoolsLoadingImage from '../images/shipschools/loader.gif';
import luggagefreeLoadingImage from '../images/luggagefree/loader.gif';
import shipplayLoadingImage from '../images/shipplay/loader.gif';

function Loading(props) {
  const { current_brand: brandId } = window.gon;

  let src;

  switch (brandId) {
    case 'shipsticks':
      src = shipsticksLoadingImage;
      break;
    case 'shipskis':
      src = shipskisLoadingImage;
      break;
    case 'shipgo':
      src = shipgoLoadingImage;
      break;
    case 'shipcamps':
      src = shipcampsLoadingImage;
      break;
    case 'shipschools':
      src = shipschoolsLoadingImage;
      break;
    case 'luggagefree':
      src = luggagefreeLoadingImage;
      break;
    case 'shipplay':
      src = shipplayLoadingImage;
      break;
    default:
      src = shipsticksLoadingImage;
  }

  return (
    <div {...props}>
      <img src={src} className="spinner" alt="Loading" />
    </div>
  );
}

export default Loading;
